/* eslint-disable max-len */
import React, { useState } from 'react';
import Cancelicon from '../../../../svgs/Cancelicon';
import DropdownIcon from '../../../../svgs/DropdownIcon';
import Styles from './Members.module.scss';

interface IMemebers{
  data:any;
  handleRemove:any
}
const Memebers = ({ data, handleRemove }:IMemebers) => {
  const [toggleState, setToggleState] = useState(true);

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__header} onClick={() => setToggleState(!toggleState)}>
        <div className={Styles.wrapper__headerTitle}>Members</div>
        <div className={toggleState ? Styles.wrapper__headerIconUp : Styles.wrapper__headerIconDown}><DropdownIcon /></div>
      </div>
      {
        toggleState && (
        <div className={Styles.wrapper__detailsContainer}>
          {
            data?.map((list:any, index:number) => (
              <div className={Styles.wrapper__detailsListContainer} key={index}>
                <div className={Styles.wrapper__detailsListTitle}>{`${list?.firstName} ${list?.lastName}`}</div>
                <div className={Styles.wrapper__detailsListAction} onClick={() => handleRemove(list)}>
                  <span><Cancelicon color="rgba(222, 55, 70, 1)" /></span>
                  Remove
                </div>
              </div>
            ))
          }

        </div>
        )
      }

    </div>
  );
};

export default Memebers;
